import * as React from 'react';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { PropertyFaqs } from './faq';
import { PropertyFaqsViewModel } from 'src/common/models';

export interface DatelessFaqsProps {
  isDateless: boolean;
  propertyFaqs: PropertyFaqsViewModel;
}

export const DatelessFaqs = ({ isDateless, propertyFaqs }: DatelessFaqsProps) =>
  isDateless && (
    <AbacusExperiment name="throttle_faq_on_pdp">
      <AbacusControl />
      <AbacusVariant bucket={1}>{<PropertyFaqs propertyFaqs={propertyFaqs} />}</AbacusVariant>
    </AbacusExperiment>
  );
